import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-user-plus',
  templateUrl: './user-plus.component.html',
  styleUrls: ['./user-plus.component.css']
})
export class UserPlusComponent {
  @Input() class = '';
  @Output() onClick = new EventEmitter();

  onClickComponent() {
    this.onClick.emit();
  }
}
